// removed by extract-text-webpack-plugin
module.exports = {"blockContainer":"wX6l6","block":"_2D1-S","root":"_2FR_Q"};